import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {birthdayGiftApi} from "@/container";

/**
 * The per-pharmacy birthday gift settings (video + auto send hour).
 */
const useBirthdayGiftSettings = () => {
    return useSwr(
        cacheKey('birthday-gift-settings'),
        () => birthdayGiftApi().settings()
    );
};

export default useBirthdayGiftSettings;
